import { ReactComponent as PendingScheduleIconSvg } from "../../images/command-hub/PendingScheduleIcon.svg";
import { SvgIcon, SvgIconProps } from "@mui/material";

const PendingScheduleIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon component={PendingScheduleIconSvg} {...props} inheritViewBox />
);

export default PendingScheduleIcon;
